import React from 'react'

import StyledStep from './StyledStep'

const Step = ({ index, title, children, ...props }) => (
  <StyledStep {...props}>
    <div className="meta">
      <div className="text">
        <div className="number">Step {index}</div>
        <span className="delimeter">-</span>
        <div className="step-title">{title}</div>
      </div>
    </div>
    <div className="content">{children}</div>
  </StyledStep>
)

export default Step
